import { INSTANCE_STATUS } from "../../../../../../../constants/instanceStatus";

export const ValidWorkStatus = consignment => {
  const {
    NULL,
    AVAILABLE,
    NOT_FOR_SALE,
    SOLD,
    ON_HOLD,
    RETURNED,
    INACTIVE,
    TO_BE_INVOICED,
    PENDING,
    ALLOCATED,
    UNCONFIRMED,
    TO_BE_RETURNED,
    CONSIGNED,
  } = INSTANCE_STATUS;

  switch (consignment?.typeId) {
    case 1:
      if (consignment.isConsignIn) {
        return [
          NULL,
          AVAILABLE,
          NOT_FOR_SALE,
          SOLD,
          ON_HOLD,
          RETURNED,
          PENDING,
          ALLOCATED,
          UNCONFIRMED,
          CONSIGNED,
        ];
      } else {
        return [NULL, AVAILABLE];
      }
    case 2:
      if (consignment.isConsignIn) {
        return [
          NULL,
          AVAILABLE,
          NOT_FOR_SALE,
          SOLD,
          ON_HOLD,
          RETURNED,
          INACTIVE,
          TO_BE_INVOICED,
          PENDING,
          ALLOCATED,
          UNCONFIRMED,
          TO_BE_RETURNED,
        ];
      } else {
        return [
          NULL,
          AVAILABLE,
          NOT_FOR_SALE,
          SOLD,
          ON_HOLD,
          RETURNED,
          TO_BE_INVOICED,
          PENDING,
          ALLOCATED,
          UNCONFIRMED,
          TO_BE_RETURNED,
        ];
      }
    case 3:
      if (consignment.isConsignIn) {
        return [NULL, AVAILABLE, SOLD, RETURNED, TO_BE_INVOICED];
      } else {
        return [];
      }
    case 4:
      if (consignment.isConsignIn) {
        return [NULL, RETURNED];
      } else {
        return [];
      }
    default:
      return [];
  }
};
